<template>
  <div class="login-container">
    <div class="login-top" id="canvas">
      <div id="anitOut"></div>
      <h3 class="title">上海商晟通云网络科技有限公司</h3>
    </div>
    <el-form autoComplete="on" :model="loginForm" ref="loginForm" label-position="left" label-width="0px" class="card-box login-form">
      <el-form-item>
        <span class="svg-container">
          <i class="fa fa-user" aria-hidden="true"></i>
        </span>
        <el-input name="userName" type="text"  @keyup.enter.native="handleLogin" v-model.trim="loginForm.userName"  placeholder="请输入用户名" class="m-t-10"></el-input>
      </el-form-item>
      <el-form-item>
        <span class="svg-container">
          <i class="fa fa-lock" aria-hidden="true"></i>
        </span>
        <el-input name="password" type="password"  @keyup.enter.native="handleLogin" v-model.trim="loginForm.password"  placeholder="请输入密码" class="m-t-10"></el-input>
      </el-form-item>
      <el-button type="primary" size="medium" class="cus-button" :loading="loading" @click.native.prevent="handleLogin">
          登录
      </el-button>
      <el-row>
        <el-col :span="12">
          <div class="login-tip">没有账号？去<el-button type="text" @click="goRegister(1)">注册</el-button></div>
        </el-col>
        <el-col :span="12">
          <div class="text-right"><el-button type="text" @click="goRegister(2)">找回密码</el-button></div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
function Login () {
  this.userName = ''
  this.password = ''
}
export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      loginForm: new Login(),
      loginRules: [
        {name: 'userName', message: '请填写用户名'},
        {name: 'password', message: '请填写密码'}
      ],
      url: this.urls.login.login,
      remem: true,
      loading: false,
    }
  },
  mounted () {
    this.$nextTick(() => {
      let userName = this.$utils.cookie.getCookie('userName')
      let passWord = this.$utils.cookie.getCookie('passWord')
      if (userName && passWord) {
        this.loginForm.userName = userName
        this.loginForm.password = passWord
      }
    })
  },
  methods: {
    handleLogin () {
      let currentEnv = process.env.NODE_ENV
      let domain = ''
      let param = {
        api: this.url,
        data: {
          username: this.loginForm.userName,
          password: this.loginForm.password,
          loginType: 'json'
        }
      }
      if (currentEnv === 'development') { // 当前是否是本地环境
        domain = ''
      } else {
        // 根据当前url拿域名。
        let fullDomain = document.domain
        domain = fullDomain.substr(fullDomain.indexOf('.'))
      }
      let gettoken = this.$utils.cookie.getCookie('Authorization')
      this.$utils.cookie.removeValue('Authorization')
      this.api.post(param).then((data) => {
        let userInfo = data.data.data.userInfo
        let tokenInfo = data.data.data.tokenInfo
        this.$utils.cookie.setCookie('Authorization', (tokenInfo.tokenType + ' ' + tokenInfo.token), this.adddays(14), '/', domain) // .apec.develop
        
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
        window.location.href = '/index.html'
      }).catch(err => {
        console.log(err)
        this.$utils.cookie.setCookie('Authorization', gettoken, this.adddays(14), '/', domain)
      })
    },
    adddays (form) {
      let DaysToAdd = form
      let newdate = new Date()
      let newtimems = newdate.getTime() + (DaysToAdd * 24 * 60 * 60 * 1000)
      newdate.setTime(newtimems)
      return newdate
    },
    goRegister (type) {
      window.location.href = '/register.html?type='+type
    }
  }
}
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  @import '../../assets/css/reset.css'
  @import '../../assets/css/common.css'
.tips {
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
}
.login-top {
  background: #409EFF;
  height: 43%;
  text-align: center;
  font-size: 30px;
}
.title {
  position: absolute;
  width: 100%;
  height: 20vh;
  box-sizing: border-box;
  padding-top: 13vh;
  text-align: center;
  top: 10vh;
  font-size: 50px;
  color: #fff;
  z-index: 1000;
  // background-image: url(../common/imge/logo.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: auto 50%;
}
.login-container {
  @include relative;
  height: 100vh;
  background-color: #fff;
  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eeeeee;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85% !important;
  }
  .svg-container {
    //padding: 6px 5px 6px 15px;
    padding:8px 15px;
    vertical-align: middle;
    font-size:20px;
    color: #889aa4;
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    top: 33%;
    width: 500px;
    padding: 35px 35px 35px 35px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 10px 10px 57px rgba(0,0,0,.17);
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    vertical-align: middle;
    // background: rgba(0, 0, 0, 0.1);
    // border-radius: 5px;
    // color: #454545;
  }
  .forget-pwd {
    color: #fff;
  }
  .cus-button{
    width:100%;height:45px;
    font-size:16px;
  }
  .text-right{
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?4edf1a6d